const overlay = document.createElement('div')
overlay.className = 'lightbox-overlay'
overlay.hidden = true

const closeButton = document.createElement('button')
closeButton.type = 'button'
closeButton.className = 'lightbox-close'
closeButton.setAttribute('aria-label', 'Close photo')
closeButton.textContent = '✕'
closeButton.hidden = true

const overlayImg = document.createElement('img')
overlay.appendChild(overlayImg)

document.body.appendChild(overlay)
document.body.appendChild(closeButton)

const open = (src, alt) => {
  overlayImg.src = src
  overlayImg.alt = alt || ''
  overlay.hidden = false
  closeButton.hidden = false
}

const close = () => {
  overlay.hidden = true
  closeButton.hidden = true
  overlayImg.src = ''
}

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('.post-media-trigger')
  if (trigger) {
    const img = trigger.querySelector('img')
    if (img) open(img.src, img.alt)
    return
  }
  if (e.target === overlay || e.target === closeButton) close()
})

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && !overlay.hidden) close()
})
